import React from "react";
import { WebcamStreamContext } from "./WebcamStreamContext";

export const useWebcamStream = () => {
  return React.useContext(WebcamStreamContext);
};

export * from "./WebcamStreamProvider";
